import script from "./StandbyServerModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./StandbyServerModal.vue?vue&type=script&setup=true&lang=ts"

import "./StandbyServerModal.vue?vue&type=style&index=0&id=3ee2643f&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ee2643f"]])

export default __exports__